import { useState } from 'react';
import { Popover } from '@ets/design-system';
import { UserPopover } from '_common/components';
import { useIEnvision, useSelector } from '_common/hooks';
import SuiteAvatar from '../SuiteAvatar/SuiteAvatar';

const UserCenter = () => {
  const isIEnvision = useIEnvision();
  const userId = useSelector((state) => state.auth.userId);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover.Root placement="bottom-end" open={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
      <Popover.Trigger>
        <div
          onClick={() => {
            if (!isIEnvision) setIsOpen(!isOpen);
          }}
          style={{ cursor: isIEnvision ? 'auto' : 'pointer' }}
          data-testid="user-popover-toggle"
        >
          <SuiteAvatar margin="0 0 0 1rem" userId={userId} />
        </div>
      </Popover.Trigger>
      <Popover.Content testId="user-profile">
        <UserPopover toggle={() => setIsOpen(false)} />
      </Popover.Content>
    </Popover.Root>
  );
};

export default UserCenter;
